module.exports = __webpack_public_path__ + "img/3.1dfb865f.jpg";